module.exports = __webpack_public_path__ + "img/main-splat.544a5a1d.svg";